// Dev
//export const apiUrlMain='https://back.mytpmschool.org:6003/'
//export const apiUrlActivity = 'https://dev-activity.mytpmschool.org:6001/v1/';
//export const apiUrlDictionary = 'https://dev-dictionary.mytpmschool.org:6002/v1/';

// Prod
 export const apiUrlActivity = 'https://mytpmschool.org:3001/v1/';
 export const apiUrlDictionary = 'https://mytpmschool.org:3002/v1/';
 export const apiUrlMain = 'https://mytpmschool.org:3003/';

// local
//export const apiUrlActivity = 'http://localhost:6001/v1/';
//export const apiUrlDictionary = 'http://localhost:6002/v1/';
//export const apiUrlMain = 'http://localhost:3003/';
